<template>
<div>
  <top-nav></top-nav>

  <search-structure ref="search" v-model="searchStructureVisible" :query="query" @change="onSearchQueryChange"></search-structure>

  <draw-structure v-model="drawStructureVisible"></draw-structure>

  <upload-structure v-model="uploadStructureVisible"></upload-structure>

  <batch-mode v-model="batchModeVisible"></batch-mode>

  <el-row class="submit-area">
    <el-col :xs="{span:22,offset:1}" :sm="{span:16,offset:4}" :md="{span:12,offset:6}" :lg="{span:10,offset:7}" class="submit-area-content">
      <div class="submit-area-title hidden-xs-only">
        Drug Targets Identification
      </div>

      <div class="submit-area-subtitle">
        Quickly identify drug targets through drug similarity
      </div>

      <div class="submit-area-input">
        <el-input size="large" v-model="query" placeholder="Name / Formula / SMILES / CHEMBL ID / HMDB ID / ZINC ID">
          <div class="submit-area-input-button" @click="$refs.search.search(query)" slot="append">Identify</div>
        </el-input>
      </div>

      <div class="submit-area-examples">
        <div class="submit-area-example" v-for="(example, i) in ['Try', 'aspirin', 'EGFR', 'C9H8O4', 'C1=CC=C(C=C1)C=O', 'CHEMBL25']" :key="i" @click="query=example; $refs.search.search(example)">
          {{ example }}
        </div>
      </div>

      <div class="submit-area-buttons">
        <div class="submit-area-button" @click="drawStructureVisible = true">
          <div class="submit-area-button-img"><img src="../assets/draw-structure-logo.png"></div>
          <div class="submit-area-button-name">Draw Structure</div>
        </div>

        <div class="submit-area-button" @click="uploadStructureVisible = true">
          <div class="submit-area-button-img"><img src="../assets/upload-structure-logo.png"></div>
          <div class="submit-area-button-name">Upload Structure</div>
        </div>
      </div>

      <div class="submit-footnote">
          <i>We provide the <b class="batch-mode-button hover-underline" @click="batchModeVisible=true">batch mode</b> to submit multiple compounds.</i>
      </div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :xs="{offset:1,span:22}" :sm="{offset:4,span:16}" :md="{span:12,offset:6}" :lg="{span:10,offset:7}" class="intro">
      <div class="intro-title">What is Drift?</div>
      <div class="intro-content">
        <p>Drift is a computational tool to predict protein targets for any unknown chemical compound.</p>
        <p>Drift generates FP2 binary fingerprint (path-based) for query compound and performs substructure search against large curated datasets of bioactive molecules with drug-like properties (<a target="_blank" href="https://www.ebi.ac.uk/chembl">ChEMBL</a>, <a target="_blank" href="http://zinc15.docking.org/">ZINC</a>, and <a target="_blank" href="http://www.hmdb.ca">HMDB</a>). The protein targets of identified bait compounds will be ranked and listed based on the extent of similarity with the query structure. Thus, Drift methodology expedite off-target prediction and drug development pipeline for any lead compound identified from experimental assays.</p>
        
        <img class="drift-method-img" src="../assets/drift-method.png">
      
        <p>We are constantly working on improving interfaces and identification accuracy. Please check back often!</p>
      </div>
    </el-col>
  </el-row>

</div>
</template>

<script>
import { bus } from '../bus.js'
import axios from 'axios'
import TopNav from './TopNav.vue'
import SearchStructure from './SearchStructure.vue'
import DrawStructure from './DrawStructure.vue'
import UploadStructure from './UploadStructure.vue'
import BatchMode from './BatchMode.vue'

export default {
  name: 'Home',

  data () {
    return {
      searchStructureVisible: false,
      drawStructureVisible: false,
      uploadStructureVisible: false,
      batchModeVisible: false,
      showTypeContent: 0,
      taskType: -1,
      query: '',
      queryResult: '',
      batchmode: false,
      taskConfig: [
        {
          title: '',
          compound: '',
          smiles: '',
          database: ['CHEMBL'],
          fpType: 'FP2',
          simCutoff: 0.1,
          num: 100
        }, {
          title: '',
          simTime: 200000,
          repT: [0.200, 0.208, 0.214, 0.220, 0.225, 0.230, 0.235, 0.240],
          repInt: 2000,
          heatExchCoeff: 0.1
        }
      ],
      content: ''
    }
  },

  components: {
    TopNav, SearchStructure, DrawStructure, UploadStructure, BatchMode
  },

  computed: {
    frontConfig () {
      return this.$store.state.frontConfig
    }
  },

  methods: {
    redirect (url) {
      window.location.href = url
    },

    onSearchQueryChange (newQuery) {
      let v = this
      v.query = newQuery
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";

.submit-title {
  border-bottom: 2px dotted #111111;
  font: normal bold 18px 'trebuchet ms', georgia, arial;
  color: $theme-color;
  margin-bottom:30px;
}

.submit-area {
  position: relative;
  background-color: $theme-color;
}

.submit-area-content {
  color: white;
  text-align: center;
}

.submit-area-title {
  font-size: 65px;
  font-weight: 200;
  margin-top: 20px;
}

.submit-area-subtitle {
  font-size: 24px;
  font-weight: 200;
  margin: 20px;
}

.submit-area-input {
}

.submit-area-input-button {
  font-size: 17px;
  cursor: pointer;
}

.submit-area-examples {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px;
}

.submit-area-example {
  cursor: pointer;
}

.submit-area-example:hover {
  opacity: 0.5;
}

.submit-area-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 16px;
}

.submit-area-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 80px;
}

.submit-area-button:hover {
  opacity: 0.5;
}

.submit-area-button-img {
  height: 50px;
}

.submit-area-button-img img {
  height: 100%;
  width: auto;
}

.submit-area-button-name {
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}

.intro {
  color: $font-grey;
  padding: 20px 0px;
}

.intro-title {
  font-size: 48px;
  text-align: center;
}

.intro-content {
  font-size: 20px;
  color: #212121;
}

.drift-method-img {
  width: 100%;
  hight: auto;
}

.batch-mode-button:hover {
  cursor: pointer;
}

.batch-content-area {
  margin: 20px 0px;
  font-size: 14px;
  text-align: left;
}

.submit-footnote {
  margin: 10px 0px;
}

</style>

